"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var ClientMixin = /** @class */ (function () {
    function ClientMixin() {
    }
    ClientMixin.prototype.getClients = function (query, callback) {
        var _this = this;
        var urlParams = { query: query };
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.ShortClient.parse, 'warn'));
        };
        this.http.get('/clients', urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.getClient = function (id, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.LongClient.parse));
        };
        this.http.get("/clients/" + id, null, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.createUser = function (commonName, givenName, surname, initials, email, password, phone, timezone, callback) {
        var _this = this;
        var body = {
            type: 'user',
            commonName: commonName,
            givenName: givenName,
            surname: surname,
            initials: initials,
            email: email,
            password: password,
            phone: phone,
            timezone: timezone,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.MinimalClient.parse));
        };
        this.http.post('/clients', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.createCommsNurse = function (commonName, givenName, surname, initials, email, password, phone, timezone, hospitalId, readOnly, callback) {
        var _this = this;
        var body = {
            type: 'commsNurse',
            commonName: commonName,
            givenName: givenName,
            surname: surname,
            initials: initials,
            email: email,
            password: password,
            phone: phone,
            timezone: timezone,
            hospitalId: hospitalId,
            readOnly: readOnly,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.MinimalClient.parse));
        };
        this.http.post('/clients', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.editClientInfo = function (clientId, email, commonName, givenName, surname, phone, initials, avlId, sendAlertForEachUnit, callback) {
        var _this = this;
        var body = {
            email: email,
            commonName: commonName,
            givenName: givenName,
            surname: surname,
            phone: phone,
            initials: initials,
            avlId: avlId,
            sendAlertForEachUnit: sendAlertForEachUnit,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/clients/" + clientId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.getClientLocation = function (clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.ClientLocation.parse));
        };
        this.http.get("/clients/" + clientId + "/location", null, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.updateClientLocation = function (clientId, latitude, longitude, callback) {
        var _this = this;
        var body = { latitude: latitude, longitude: longitude };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/clients/" + clientId + "/location", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.addClientToAgency = function (clientId, agencyId, isManager, isDispatcher, addToAllUnits, callback) {
        var _this = this;
        var body = {
            agencyId: agencyId,
            isManager: isManager,
            isDispatcher: isDispatcher,
            addToAllUnits: addToAllUnits,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/clients/" + clientId + "/agencies", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.editClientAgencyMembership = function (clientId, agencyId, isManager, isDispatcher, callback) {
        var _this = this;
        var body = {
            isManager: models_1.FieldUtils.getEditableParam(isManager),
            isDispatcher: models_1.FieldUtils.getEditableParam(isDispatcher),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/clients/" + clientId + "/agencies/" + agencyId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.removeClientFromAgency = function (clientId, agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/clients/" + clientId + "/agencies/" + agencyId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.addClientToUnit = function (clientId, unitId, callback) {
        var _this = this;
        var body = {
            unitId: unitId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/clients/" + clientId + "/units", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.removeClientFromUnit = function (clientId, unitId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/clients/" + clientId + "/units/" + unitId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.getPreAlertCheck = function (clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.PreAlertCheck.parse));
        };
        this.http.get("/clients/" + clientId + "/pre-alert-check", null, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.getAlertCheck = function (clientId, membershipId, deviceId, callback) {
        var _this = this;
        var urlParams = {
            membershipId: membershipId,
            deviceId: deviceId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.AlertCheckIssue.parse, 'warn'));
        };
        this.http.get("/clients/" + clientId + "/alert-check", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.getClientEmailLog = function (clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.ClientEmailLogItem.parse, 'warn'));
        };
        this.http.get("/clients/" + clientId + "/email-log", null, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.getClientGraves = function (clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.Grave.parse, 'warn'));
        };
        this.http.get("/clients/" + clientId + "/graves", null, this.unauthenticatedCallback(wrappedCallback));
    };
    ClientMixin.prototype.setClientStatus = function (clientId, status, reason, callback) {
        var _this = this;
        var body = { reason: reason, status: status };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/clients/" + clientId + "/status", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    return ClientMixin;
}());
exports.default = ClientMixin;
//# sourceMappingURL=ClientMixin.js.map